import { render, staticRenderFns } from "./IconOfficeBuilding.vue?vue&type=template&id=3e423482&"
import script from "./IconOfficeBuilding.vue?vue&type=script&lang=js&"
export * from "./IconOfficeBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports